import { createContext, useContext, useState,useEffect,useLayoutEffect } from 'react';
import {getUserId } from "./lib/auth"
import {getIdData } from "./lib/profiles"


const Context = createContext();

export const UserProvider = ({ children }) => {
	const [profile, setProfile] = useState()

	async function GetData() {
		let user = JSON.parse(localStorage.getItem('eplus'))
		console.log('context', user)

		if (user) {
			setProfile(user[0])
		} else {
			const user = await getUserId()
			const userprofile = await getIdData(user)
			setProfile(userprofile[0])
		}
	}

	useEffect(() => {
		GetData()
	}, [])

	useLayoutEffect(() => {
		GetData()
	}, [])

	const data = {
		profile,
		setProfile
	}

	return <Context.Provider value={data}>{children}</Context.Provider>
}

export const useAuth = () => useContext(Context)

export const UserContext = createContext({
	profile: '',
	setProfile: () => {}
})